import {
  FETCH_LOANHISTORY,
  FETCH_LOANHISTORY_FAILURE,
  FETCH_LOANHISTORY_SUCCESS,
} from '../../actions/loanActions'

const intialLoanHistoryState = {
  data: [],
  loading: false,
}

const loanHistoryReducer = (state = intialLoanHistoryState, action) => {
  switch (action.type) {
    case FETCH_LOANHISTORY:
      return {
        ...state,
        loading: true,
      }
    case FETCH_LOANHISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      }
    case FETCH_LOANHISTORY_FAILURE:
      return {
        ...state,
        loading: false,
      }
    default:
      return state
  }
}

export default loanHistoryReducer
